// extracted by css-extract-rspack-plugin
export default {"lazy":"_96501df6","lazyWithLineBreak":"_4c6d96a5"};